'use strict';

angular.module('fileUploadApp')
    .controller('FileUploadController',['$http', '$scope', '$rootScope', '$stateParams','Principal','fileManagerConfig', function ($http, $scope, $rootScope, $stateParams, Principal, config) {
    	$scope.files=[];


    	//config.allowedActions.move=false;

    	Principal.identity().then(function(user) {
        	$scope.curUser = user;

        	if($scope.curUser.authorities instanceof Array) {
        		var isClient = $scope.curUser.authorities.some(function(a) {
        			return a == "ROLE_CLIENT";
        		})

        		var isProcessor = $scope.curUser.authorities.some(function(a) {
                	return a == "ROLE_PROCESSOR";
                })

        		var isAdmin = $scope.curUser.authorities.some(function(a) {
                    return a == "ROLE_ADMIN";
                })

        		if(isClient){
        			config.allowedActions.upload=true;
        			config.allowedActions.rename=false;
        			config.allowedActions.move=false;
        			config.allowedActions.copy=false;
        			config.allowedActions.edit=false;
        			config.allowedActions.changePermissions=false;
        			config.allowedActions.compress=false;
        			config.allowedActions.compressChooseName=false;
        			config.allowedActions.extract=false;
        			config.allowedActions.download=true;
        			config.allowedActions.downloadMultiple=true;
        			config.allowedActions.preview=true;
        			config.allowedActions.remove=false;
        			config.allowedActions.createFolder=false;
        		}
        		if(isProcessor){
        			config.allowedActions.upload=true;
        			config.allowedActions.rename=true;
        			config.allowedActions.move=true;
        			config.allowedActions.copy=false;
        			config.allowedActions.edit=false;
        			config.allowedActions.changePermissions=false;
        			config.allowedActions.compress=false;
        			config.allowedActions.compressChooseName=false;
        			config.allowedActions.extract=false;
        			config.allowedActions.download=true;
        			config.allowedActions.downloadMultiple=true;
        			config.allowedActions.preview=true;
        			config.allowedActions.remove=false;
        			config.allowedActions.createFolder=true;
        		}
        		if(isAdmin){
        			config.allowedActions.upload=true;
        			config.allowedActions.rename=true;
        			config.allowedActions.move=true;
        			config.allowedActions.copy=false;
        			config.allowedActions.edit=false;
        			config.allowedActions.changePermissions=false;
        			config.allowedActions.compress=false;
        			config.allowedActions.compressChooseName=false;
        			config.allowedActions.extract=false;
        			config.allowedActions.download=true;
        			config.allowedActions.downloadMultiple=true;
        			config.allowedActions.preview=true;
        			config.allowedActions.remove=true;
        			config.allowedActions.createFolder=true;
        		}
        	}




        });

    	/*$(function () {
    	    $('#fileupload').fileupload({
    	        dataType: 'json',

    	        done: function (e, data) {
    	            $("tr:has(td)").remove();
    	            console.log(data.result);

    	            $scope.files=data.result;
    	        },

    	        progressall: function (e, data) {
    	            var progress = parseInt(data.loaded / data.total * 100, 10);
    	            $('#progress .bar').css(
    	                'width',
    	                progress + '%'
    	            );
    	        },

    	    });
    	});

    	$http.get('api/tempFile/load').then(function(response) {
     		if(response.data && response.data instanceof Array) {
     			$("tr:has(td)").remove();
	            console.log(response.data);

	            $scope.files=response.data;

     		}
     	});

    	$scope.openDirectory = function(path){
    		console.log(path);
    		$http({
        		method: 'POST',
        		url: 'api/tempFile/loadDirectory',
        		data: path
        	}).then(function (response) {
        		if(response.data && response.data instanceof Array) {
        			$("tr:has(td)").remove();
   	            console.log(response.data);

   	            $scope.files=response.data;

        		}
        	});
    	}

    	$scope.download = function(){


    		var url = "api/tempFile/get/all"

    				var hiddenElement = document.createElement('a');

    	            hiddenElement.href = url;
    	            hiddenElement.target = '_blank';
    	            //hiddenElement.download = 'myFile.xls';
    	            hiddenElement.click();
    	}*/


    }]);
